import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		padding: `0px !important`,
	},
	paddingContent: {
		paddingLeft: theme.spacing.unit,
		paddingRight: theme.spacing.unit * 2,
	},
	containerHeight: {
		height: '400px',
		overflow: 'auto',
	},
	addCommentBtn: {
		float: 'right',
	},
	commentTitle: {
		float: 'left'
	},
	navigation: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		padding: 0,
		margin: 0,
		paddingBottom: '10px',

		'& > li': {
			display: 'inline-flex',
			alignItems: 'center',
			marginRight: theme.spacing.unit * 1,
			'&:last-child': {
				marginRight: 0,
			},
			'&.active > a': {
				color: theme.palette.text.primary,
			},

			'& > a': {
				...theme.typography.subtitle2,
				color: theme.palette.grey[500],
				textDecoration: 'none',
				display: 'inline-block',
				transition: 'all 0.2s linear',
			}
		}
	},
	moreMenu: {
		'& li': {
			height: 'auto',
			fontSize: '0.8rem',
			padding: 0,
			'& > a': {
				display: 'inline-block',
				width: '100%',
				height: theme.spacing.unit * 2,
				...theme.mixins.gutters(),
				color: theme.palette.text.secondary,
				paddingTop: theme.spacing.unit,
				paddingBottom: theme.spacing.unit,
				textDecoration: 'none',
				'&:hover': {
					textDecoration: 'none',
				}
			},
			'& > svg': {
				marginRight: theme.spacing.unit,
				fontSize: '1rem',
			}
		}
	},
	dialogCloseContainer: {
		textAlign: 'right',
	},
	textCapitalize: {
		textTransform: 'capitalize'
	},
	replyPlaceHolder: {
		position: 'absolute',
		top: theme.spacing.unit,
		left: theme.spacing.unit,
		opacity: 0.5,
	},
	zeroPadding: {
		padding: 0
	},
	mb1x5x: {
		marginBottom: theme.spacing.unit * 1.5,
	},
	colorAvatar: {
		width: '60px',
		height: '60px',
		margin: '10px',
		color: '#fff',
	},
	commentGridBox: {
		paddingTop: theme.spacing.unit,
		paddingBottom: theme.spacing.unit,
	},
	avatar: {
		margin: 10,
		width: 60,
		height: 60,
	},
	replyAvatar: {
		margin: 10,
		width: 50,
		height: 50,
	},
	miniAvater: {
		width: 25,
		height: 25,
	},
	listTypo: {
		fontSize: '0.8em',
	},
	bold: {
		fontWeight: "bold",
	},
	profileWrapper: {
		marginRight: theme.spacing.unit,
	},
	justifyContent: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	paddingZero: {
		padding: `0px !important`
	},
	moreMenuButton: {
		position: 'absolute',
		right: 0,
		top: 0,
		padding: 0,
	},
	commentTime: {
		position: 'absolute',
		right: '20px',
		top: 0,
	},
	suggesedtedUser: {
		width: '100%',
		maxWidth: 360,
		backgroundColor: `rgba(220,220,220,0.3)`,
		position: "absolute",
		cursor: "pointer",
	},
	top35: {
		top: "35%",
	},
	editableBox: {
		minHeight: "150px",
		border: `1px solid ${theme.palette.grey[300]}`,
		background: theme.palette.background.paper,
		whiteSpace: "normal",
		marginBottom: theme.spacing.unit,
		paddingLeft: theme.spacing.unit / 2,
	},
	nonEditableBox: {
		background: theme.palette.background.paper,
		whiteSpace: "normal",
		marginBottom: theme.spacing.unit,
		paddingLeft: theme.spacing.unit / 2,
	},
	editableBoxReply: {
		minHeight: "40px",
		border: `1px solid ${theme.palette.grey[300]}`,
		background: theme.palette.background.paper,
		whiteSpace: "normal",
		width: "380px",
		marginBottom: theme.spacing.unit,
		paddingLeft: theme.spacing.unit,
		paddingTop: theme.spacing.unit,
	},
	contentEditable: {
		fontSize: "1rem",
		fontFamily: `'Roboto', 'sans-serif'`,
		fontWeight: 400,
		lineHeight: 1.5,
		padding: theme.spacing.unit,
	},
	repliesEdit: {
		display: "flex",
		float: "right",
		padding: theme.spacing.unit / 2,
	},
	blockHover: {
		cursor: "block",
	},
	markedResolved: {
		opacity: 0.7,
		paddingLeft: theme.spacing.unit / 2,
		fontSize: "12px",
	}
});